import moment from 'moment';
import { Control, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { formStyles } from '../../styles/forms';
import { Colors } from '../../themes';
import { DatePickerSelector } from '../forms';

type QuickReminderFieldProps = {
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

export const QuickReminderField = ({
  control,
  setValue,
}: QuickReminderFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <View>
        <Text style={formStyles.formItemTitleCropCircle}>
          {t('issue.quickReminder.header')}
        </Text>
      </View>
      <Text style={styles.subheader}>{t('issue.quickReminder.subheader')}</Text>
      <DatePickerSelector
        name="quickReminderDate"
        setValue={setValue}
        control={control}
        label=""
        placeholder={t('issue.dateFormat')}
        maxYears={5}
        minDate={moment().add(1, 'day').format('YYYY-MM-DD')}
        hideCalendarIcon
      />
    </>
  );
};

const styles = StyleSheet.create({
  subheader: {
    color: Colors.grayText,
    fontSize: 14,
    fontWeight: '400',
    marginBottom: 8,
  },
});
